/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, ReactNode, useContext } from "react";

type ToggleVisibilityContextValue = {
  visible: boolean;
  toggleVisibility: () => void;
};

type ToggleVisibilityProviderProps = ToggleVisibilityContextValue & {
  children: ReactNode;
};

const ToggleVisibilityContext = createContext<ToggleVisibilityContextValue>(
  {} as ToggleVisibilityContextValue,
);

export const ToggleVisibilityProvider = (
  props: ToggleVisibilityProviderProps,
) => {
  const { visible, toggleVisibility, children } = props;

  return (
    <ToggleVisibilityContext.Provider value={{ visible, toggleVisibility }}>
      {children}
    </ToggleVisibilityContext.Provider>
  );
};

export const useToggleVisibility = (): ToggleVisibilityContextValue => {
  const context = useContext(ToggleVisibilityContext);

  if (!context) {
    throw new Error("Component beyond ToggleVisibilityContext");
  }

  return context;
};
